/**
 * Google Font Selection
 * =====================
 */

export default [{
  familyName: 'Abril Fatface',
  genericFamily: 'cursive',
  source: 'google'
}, {
  familyName: 'Advent Pro',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Amiri',
  genericFamily: 'serif',
  source: 'google'
}, {
  familyName: 'Arimo',
  genericFamily: 'sans-serif',
  source: 'google',
  tags: [
    '400', '500', '600', '700'
  ],
}, {
  familyName: 'Bitter',
  genericFamily: 'serif',
  source: 'google'
}, {
  familyName: 'Cardo',
  genericFamily: 'serif',
  source: 'google'
}, {
  familyName: 'Catamaran',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Dosis',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Ek Mukta',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Fira Sans',
  genericFamily: 'sans-serif',
  tags: [
    '300', '300i', '400', '500', '700'
  ],
  source: 'google'
}, {
  familyName: 'Fredoka One',
  genericFamily: 'cursive',
  source: 'google'
}, {
  familyName: 'Inknut Antiqua',
  genericFamily: 'serif',
  source: 'google'
}, {
  familyName: 'Lato',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Libre Baskerville',
  genericFamily: 'serif',
  source: 'google'
}, {
  familyName: 'Lora',
  genericFamily: 'serif',
  source: 'google'
}, {
  familyName: 'Martel',
  genericFamily: 'serif',
  source: 'google'
}, {
  familyName: 'Merriweather',
  genericFamily: 'serif',
  source: 'google'
}, {
  familyName: 'Montserrat',
  genericFamily: 'sans-serif',
  source: 'google',
  tags: [
    '100', '200', '300', '400', '700', '900'
  ],
}, {
  familyName: 'Nunito',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Open Sans',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Oswald',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Palanquin Dark',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Patua One',
  genericFamily: 'cursive',
  source: 'google'
}, {
  familyName: 'Playfair Display',
  genericFamily: 'serif',
  source: 'google'
}, {
  familyName: 'Poppins',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'PT Serif',
  genericFamily: 'serif',
  source: 'google'
}, {
  familyName: 'Questrial',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Raleway',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Roboto',
  genericFamily: 'sans-serif',
  tags: [
    300, '300i', 400, '400i', 700, 900
  ],
  source: 'google'
}, {
  familyName: 'Roboto Condensed',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Rubik',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Sarpanch',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Titillium Web',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Varela Round',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Work Sans',
  genericFamily: 'sans-serif',
  source: 'google',
  tags: [300, 400]
}, {
  familyName: 'Cantarell',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Crimson Text',
  genericFamily: 'serif',
  source: 'google'
}, {
  familyName: 'Domine',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Muli',
  genericFamily: 'sans-serif',
  source: 'google',
  tags: [300, '300i', 400]
}, {
  familyName: 'Neuton',
  genericFamily: 'serif',
  source: 'google'
}, {
  familyName: 'Fanwood Text',
  genericFamily: 'serif',
  source: 'google'
}, {
  familyName: 'Archivo Narrow',
  genericFamily: 'sans-serif',
  source: 'google'
}, {
  familyName: 'Enriqueta',
  genericFamily: 'serif',
  source: 'google'
}]
